import {useState,useContext,useEffect, useMemo, memo} from 'react';
import {  useSettingModal } from '../../../../hooks/Context';
import css3 from '../../Approvals/css/approval-table.module.css';
import {MdOutlineArrowBackIosNew as LBtn,MdOutlineArrowForwardIos as RBtn} from 'react-icons/md';
import {FiMoreHorizontal as MoreIcon} from 'react-icons/fi';
import { convertTimetoString } from '../../../../helperFunction';
import css4 from '../../Approvals/css/approval-table.module.css';
import PaymentDurationModal from '../Modal/settingsCustomModal'
import ViewPaymentDuration from './ViewPaymentDuration';
import EditPaymentDuration from './Edit-CreatePaymentEdition';


interface PaymentDurationDetails {
    Id: number;
    PaymentType: string;
    StartDate: string;
    EndDate: string;
    IsActive: boolean;
  }

  interface PaymentDurationTableProps {
    data?: PaymentDurationDetails[]
  }

  const DATA_PER_PAGE = 10;

const PaymentDurationTable = ({data = []}: PaymentDurationTableProps) =>{
    const [activeData,setActiveData] = useState<any>([]);
    const [pageData,setPageData] = useState<any>([]);
    const [currentPage,setCurrentPage] = useState<number>(0);
    const [pageArr,setPageArr] = useState<any>([]);
    const [showMore,setShowMore] = useState<boolean>(false);
    const [showIndex,setShowIndex] = useState<any>(null);
    const [showSpan,setShowSpan] = useState<boolean>(false);
    const [spanIndex,setSpanIndex] = useState<null | number>(null);
    //const {setShowModal,setModalContent:setModalView} = useSettingModal()
    const [openViewPaymentDuration, setOpenViewPaymentDuration] = useState(false);
    const [openEditPaymentDuration, setOpenEditPaymentDuration] = useState(false);
    const [paymentDurationData, setPaymentDurationData] = useState({} as PaymentDurationDetails)

    
  
    // const data1 = [
    //   {
    //       applicantId: 'applicant Id',
    //       firstName: 'first Name',
    //       lastName: 'Last Name',
    //       certificateScore: 'Certificate Score',
    //       trainingScore: 'Training Score',
    //       route: 'Route'
    //   }
    // ]

    // const data= useMemo(() => data1, []);
  
    const handlePrevous = () =>{
  
    }
  
    const handleNext = ()=>{
  
    }
  
    const handleMore = (index:number) =>{
        if(index == showIndex){
            setShowIndex(null);
            setShowMore(false);
            return
        }
        setShowIndex(index);
        setShowMore(true);
    }
    const handleSpan = (index:number) =>{
        if(index == spanIndex){
            setSpanIndex(null);
            setShowSpan(false);
            return
        }
        setSpanIndex(index);
        setShowSpan(true);
    }
  
    const handleViewPaymentDuration =(data:PaymentDurationDetails )=>{
        setPaymentDurationData(data);
        setOpenViewPaymentDuration(true);
    }

    const handleEditPaymentDuration = (data: PaymentDurationDetails) => {
        setPaymentDurationData(data);
        setOpenEditPaymentDuration(true);
    }
  
    
  
    
  
    useEffect(()=>{
        if(data && data.length > 0){
            
            setActiveData(data);
            let lastPage = Math.ceil(data.length/10);
            let i = 0;
            let arr = [];
            for(i = 0;i<lastPage;i++){
                arr.push(i);
            }
            
            setPageArr(arr);
            setPageData(data.slice(0,DATA_PER_PAGE));
        }
    },[data])
  
    useEffect(()=>{
        if(activeData && activeData.length > 0){    
            let start = currentPage*DATA_PER_PAGE;
            let stop = start+DATA_PER_PAGE;
            setPageData(data.slice(start,stop));  
        }
    },[currentPage])
  
    return (
        <div className={css3.container}>
           
            <>
                <div style={{gridTemplateColumns:`repeat(3,.8fr) 1fr`}}>
                    <div>Payment Action</div>
                    <div>Start Date</div>
                    <div>End Date</div>
                    <div>Status</div>
                </div>
                <div>
                    {pageData && pageData.length > 0 && pageData?.map((eData:PaymentDurationDetails,index:number):any =>
                      <div key={index} style ={{gridTemplateColumns:`repeat(3,.8fr) 1fr`}}>
                          <div onClick={() => handleSpan(index)}>{eData.PaymentType}</div>
                          <div onClick={() => handleSpan(index)}>{convertTimetoString(eData?.StartDate,0)}</div>
                          <div onClick={() => handleSpan(index)}>{convertTimetoString(eData?.EndDate, 0) }</div>
                          <div>
                            {eData?.IsActive?'Active':'Disabled'}
                            <span className={css4.moreSpan}><MoreIcon />
                            </span>
                            <span  className={`${css4.moreSpan} ${index == showIndex?`${css4.activeMore}`:''} `} onClick={()=>handleMore(index)}><MoreIcon />
                                {index == showIndex && showMore ?<div>
                                    <div onClick={() => handleViewPaymentDuration(eData)} >View Details</div>
                                    <div onClick={()=>handleEditPaymentDuration(eData)}>Edit Details</div>
                                </div>:''}
                            </span>
                        </div>
                      </div>
                    )}
                </div>
                <div className={css3.pagination}>
                    <div>
                        <button className={`${css3.lBtn} ${css3.btn}`}><LBtn/></button>
                        {pageArr && pageArr.length > 0 && pageArr.map((ePage: number, index: number) => {

                            if(index <= 2 && currentPage <= 2) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index == currentPage ) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index >= pageArr.length - 3 && currentPage >= pageArr.length -3) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index == pageArr.length-1) return (
                            <>
                                <>...</>
                                <span 
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>
                            </>
                            )  

                            if(index == 0 ) return (
                            <>
                                <span 
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>
                                <>...</>
                            </>)  

                            })} 
                        <button className={`${css3.rBtn} ${css3.btn}`}><RBtn/></button>
                    </div>
                </div>
            </>
            
            <PaymentDurationModal 
                cancel ={setOpenViewPaymentDuration} 
                open = {openViewPaymentDuration}
                maxWidth = {'712px'}
                header={'Payment Duration'}
                showrightIcon={false}
                content = {
                    <ViewPaymentDuration data={paymentDurationData} />
                }

            />
            <PaymentDurationModal 
                cancel ={setOpenEditPaymentDuration} 
                open = {openEditPaymentDuration}
                maxWidth = {'712px'}
                header={'Payment Duration'}
                showrightIcon={false}
                content = {
                    <EditPaymentDuration state='update' data={paymentDurationData} cancel={setOpenEditPaymentDuration}/>
                }

            />
        </div>
    )
  }

  export default PaymentDurationTable;